module.exports = __webpack_public_path__ + "static/media/repositorie-icon.d28d4a14.svg";